module.exports = __webpack_public_path__ + "img/icon_material_cumulative_gj_1.05befb58.webp";